<template>
  <div class="tag-cloud">
    <span
      v-for="tag in tags"
      :key="tag.text"
      class="tag"
      :class="tag.weight || 'low'"
    >{{ tag.text }}</span>
  </div>
</template>

<script>
// 标签云：tags = [{ text, weight: 'hot' | 'mid' | 'low' }]
export default {
  name: 'TagCloud',
  props: {
    tags: { type: Array, default: () => [] },
  },
};
</script>
